import { api } from '../core';
import type { RootState } from '@/store';
import { refreshBundleSectionsWithCurrentFilters } from './getBundleSections';

type BundleRetrieveMissingResponse = null;

export type BundleRetrieveMissingProps = {
  bundleId: string;
  pageId: string;
  pagesBefore: string[];
  pagesAfter: string[];
};

const bundleRetrieveMissingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postBundleRetrieveMissing: builder.query<BundleRetrieveMissingResponse, BundleRetrieveMissingProps>({
      query: ({ bundleId, pageId, pagesBefore, pagesAfter }: BundleRetrieveMissingProps) => ({
        url: 'bundle/retrieve-missing',
        method: 'POST',
        body: { bundleId, pageId, pagesBefore, pagesAfter },
      }),
      async onQueryStarted(_args, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;

          const state = getState() as RootState;
          refreshBundleSectionsWithCurrentFilters(dispatch, state);
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postBundleRetrieveMissing in onQueryStarted:', error);
          }
        }
      },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostBundleRetrieveMissingQuery } = bundleRetrieveMissingApi;
